import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const usuarioLogado = localStorage.getItem('usuario');
  
  if (!usuarioLogado) {
    // Se não há usuário logado, redireciona para login
    return <Navigate to="/login" replace />;
  }

  try {
    // Verifica se os dados do usuário são válidos
    const usuario = JSON.parse(usuarioLogado);
    if (!usuario.id || !usuario.nome) {
      // Se os dados estão corrompidos, remove e redireciona
      localStorage.removeItem('usuario');
      return <Navigate to="/login" replace />;
    }
  } catch (error) {
    // Se há erro ao parsear, remove e redireciona
    localStorage.removeItem('usuario');
    return <Navigate to="/login" replace />;
  }

  // Se tudo está ok, renderiza o componente filho
  return children;
}
